// @/js/core/utils/events-api.js
import { apiRequest } from './api';
import qs from 'qs';

export async function listEvents(params = {}, type, key) {
  // Use URLSearchParams to turn the object into: ?start_after=2026-03-01&per_page=100
  const searchParams = new URLSearchParams(qs.stringify(params));
  const query = searchParams.toString();
  const typeSegment = type === 'displays' ? '/digital-display' : '';
  const keySegment = key ? `/key/${key}` : '';

  return apiRequest(`/events${typeSegment}${keySegment}${query ? `?${query}` : ''}`);
}

export function nextEventsPage(pagination, currentPage) {
  if (typeof pagination?.has_more === 'boolean') {
    return pagination.has_more ? Number(pagination.next_page || currentPage + 1) : null;
  }

  const lastPage = Number(pagination?.last_page || 1);

  return currentPage < lastPage ? currentPage + 1 : null;
}

export async function getEventFilterOptions(params = {}) {
  const searchParams = new URLSearchParams(qs.stringify(params));
  const query = searchParams.toString();

  return apiRequest(`/events/filter-options${query ? `?${query}` : ''}`);
}

export async function getEvent(eventPageSlug) {
  return apiRequest(`/events/${encodeURIComponent(eventPageSlug)}`);
}

export async function getLivestreamHud(params = {}) {
  const searchParams = new URLSearchParams(qs.stringify(params));
  const query = searchParams.toString();

  return apiRequest(`/events/livestream-hud${query ? `?${query}` : ''}`);
}

export async function getLivestreamInstructions() {
  return apiRequest('/events/livestream-instructions');
}
